export interface ValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Validates a PR title.
 * - Required (non-empty, non-whitespace-only)
 * - Must be between 1 and 256 characters
 */
export function validatePRTitle(title: string): ValidationResult {
  if (!title || title.trim().length === 0) {
    return { valid: false, error: 'Title is required' };
  }
  if (title.length > 256) {
    return { valid: false, error: 'Title must be at most 256 characters' };
  }
  return { valid: true };
}

/**
 * Validates a PR description.
 * - Optional (empty string is valid)
 * - Maximum 10240 characters
 */
export function validatePRDescription(description: string): ValidationResult {
  if (description.length > 10240) {
    return { valid: false, error: 'Description must be at most 10240 characters' };
  }
  return { valid: true };
}

/**
 * Validates a comment body.
 * - Required (non-empty, non-whitespace-only)
 * - Must be between 1 and 65536 characters
 */
export function validateComment(text: string): ValidationResult {
  if (!text || text.trim().length === 0) {
    return { valid: false, error: 'Comment is required' };
  }
  if (text.length > 65536) {
    return { valid: false, error: 'Comment must be at most 65536 characters' };
  }
  return { valid: true };
}

/**
 * Validates a reply body.
 * - Required (non-empty, non-whitespace-only)
 * - Must be between 1 and 10240 characters
 */
export function validateReply(text: string): ValidationResult {
  if (!text || text.trim().length === 0) {
    return { valid: false, error: 'Reply is required' };
  }
  if (text.length > 10240) {
    return { valid: false, error: 'Reply must be at most 10240 characters' };
  }
  return { valid: true };
}

/**
 * Validates that source and destination branches are different.
 * - Both must be non-empty
 * - Source must not equal destination
 */
export function validateBranches(source: string, destination: string): ValidationResult {
  if (!source || !destination) {
    return { valid: false, error: 'Both source and destination branches are required' };
  }
  if (source === destination) {
    return { valid: false, error: 'Source and destination branches must be different' };
  }
  return { valid: true };
}
